import React, { useState } from 'react';
import { AppButton, useToaster } from '@frontend-modules/ui-kit';
import { onlineLessonsProvider } from '@fsd-entities/online-lessons';

export const MeetingEnterButton: React.FC<{ url: string }> = ({ url }) => {
    const [isEnterButtonLoading, setIsEnterButtonLoading] = useState(false);
    const { showErrorToast } = useToaster();

    const handleButtonClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        setIsEnterButtonLoading(true);
        void onlineLessonsProvider
            .getOnlineLessonLink(url)
            .then(({ link, url, block }) => {
                const apiUrl = link || url;

                if (!block && apiUrl) {
                    window.open(apiUrl, '_blank', 'noopener noreferrer');
                } else {
                    showErrorToast({
                        message: 'Невозможно перейти в комнату',
                    });
                }
            })
            .finally(() => setIsEnterButtonLoading(false));
    };

    return (
        <AppButton
            label={'Войти'}
            onClick={(event) => handleButtonClick(event)}
            loading={isEnterButtonLoading}
            disabled={!url}
        />
    );
};
